(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCall', PhoneCall);

    PhoneCall.$inject = ['$resource', 'DateUtils'];

    function PhoneCall ($resource, DateUtils) {
        var resourceUrl =  'api/phone-calls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.callTime = DateUtils.convertDateTimeFromServer(data.callTime);
                        data.createTime = DateUtils.convertDateTimeFromServer(data.createTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
